export const SYSTEM_KEYS_ATTR_MAP = {
    projectName: 'projectname',
    requestId: 'requestid',
    versionCommit: 'versioncommit',
};
export const SYSTEM_KEYS_QUERY_MAP = {
    projectName: 'projectName',
    requestId: 'requestId',
    versionCommit: 'versionCommit',
};
export const SYSTEM_KEYS = {
    projectName: 'projectName',
    requestId: 'requestId',
    versionCommit: 'version.commit',
};
//# sourceMappingURL=constants.js.map